import { render } from "./ArmoryProfilePanel.vue?vue&type=template&id=11ae613c"
import script from "./ArmoryProfilePanel.vue?vue&type=script&lang=js"
export * from "./ArmoryProfilePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__